<template>
    <div>
        <div>
            <el-form ref="teacher" :model="$parentInfo.Dialog_GiveTeacherToSemester.filter"
                     label-width="70px">
                <el-form-item label="学科">
                    <el-select
                            v-model="$parentInfo.Dialog_GiveTeacherToSemester.filter.subject_id"
                            placeholder="请选择学科" style="width: 200px"
                            clearable
                            @change="handleSearchTeacher('')">
                        <el-option
                                v-for="item in $parentInfo.subjects"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="老师">
                    <el-select
                            v-model="$parentInfo.Dialog_GiveTeacherToSemester.filter.teacher_id"
                            placeholder="请选择老师"
                            filterable remote
                            :remote-method="handleSearchTeacher"
                            style="width: 200px">
                        <el-option
                                v-for="item in $parentInfo.Dialog_GiveTeacherToSemester.teachers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="授课学期">
                    <el-select
                            v-model="$parentInfo.Dialog_GiveTeacherToSemester.filter.semester_id"
                            disabled
                            placeholder="请选择授课学期"
                            style="width: 200px">
                        <el-option
                                v-for="item in $parentInfo.semesters"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="text-right">
            <el-button @click="handleStoreTeacher" :loading="$parentInfo.dialog_CreateTeacher.button_loading">保存</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_GiveTeacherToSemester",
        data() {
            return {
                semester_id:'',
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.Dialog_GiveTeacherToSemester.filter.semester_id=this.$parentInfo.filter.semester_id
            this.$parentInfo.Dialog_GiveTeacherToSemester.filter.section_id=this.$parentInfo.filter.section_id
            this.handleTeacherNotInSemester();
        },
        destroyed(){
            this.$parentInfo.Dialog_GiveTeacherToSemester.filter.subject_id=''
            this.$parentInfo.Dialog_GiveTeacherToSemester.filter.teacher_id=''
        },
        methods: {
            handleTeacherNotInSemester(){
                this.$wApi.send(this.$parentInfo.path, 'get_teacher_notIn_semester', {
                    'semester_id': this.$parentInfo.filter.semester_id
                });
            },
            handleSearchTeacher(query){
                this.$wApi.send(this.$parentInfo.path, 'search_teacher_notIn_semester', {
                    'name': query,
                    'subject_id':this.$parentInfo.Dialog_GiveTeacherToSemester.filter.subject_id,
                    'semester_id': this.$parentInfo.filter.semester_id
                });
            },
            handleStoreTeacher() {
                this.$confirm('确认创建?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_CreateTeacher.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'give_teacher_to_semester', {
                        'filter': this.$parentInfo.Dialog_GiveTeacherToSemester.filter
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
        }
    }
</script>
